/**
 * Get short date format string based on locale
 * @param locale
 */
export function getShortDateFormatForLocale(locale: string): string {
    const formatMap: Record<string, string> = {
        'en-US': 'MM/dd/yyyy',
        'fr-FR': 'dd/MM/yyyy',
        'es-ES': 'dd/MM/yyyy',
        'pt-BR': 'dd/MM/yyyy',
        'it-IT': 'dd/MM/yyyy',
        'da-DK': 'dd-MM-yyyy',
        'nl-NL': 'dd-MM-yyyy',
        'de-DE': 'dd.MM.yyyy',
        'ru-RU': 'dd.MM.yyyy',
        'pl-PL': 'dd.MM.yyyy',
        'sv-SE': 'yyyy-MM-dd',
        'zh-CN': 'yyyy-MM-dd',
        'ko-KR': 'yyyy.MM.dd'
    };

    return formatMap[locale] || 'shortDate';
}
